<template>
  <div id="bindMobile">
    <div class="form">
      <el-form :label-position="labelPosition" label-width="150px">
        <el-form-item label="输入手机号：">
          <el-input v-model="form.mobile"></el-input>
        </el-form-item>
        <el-form-item label="输入图片验证码：">
          <el-row :gutter="20">
            <el-col :span="12" style="padding:0">
              <div>
                <el-input v-model="form.imgCode"></el-input>
              </div>
            </el-col>
            <el-col :span="6">
              <div>
                <img :src="codeSrc" />
              </div>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="输入短信验证码：">
          <el-row :gutter="20">
            <el-col :span="12" style="padding:0">
              <div>
                <el-input v-model="form.msgCode"></el-input>
              </div>
            </el-col>
            <el-col :span="6">
              <div>
                <el-button :disabled="msgDisable" plain @click="getMessageCode">{{text1}}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <div align="center" style="padding-top:50px">
        <el-button type="primary" size="large" class="submit" @click="submit">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //
      serve: this.$store.state.serve,
      msgDisable: false,
      text1: "获取验证码",
      labelPosition: "right",
      form: {
        mobile: "",
        imgCode: "",
        msgCode: ""
      },
      codeSrc: ""
    };
  },

  created() {
    this.axios.get(this.serve + "/verify_code").then(res => {
      this.codeSrc = "data:image/jpeg;base64," + res.data;
    });
  },
  methods: {
    alert_success(message) {
      this.$message({
        message: message,
        type: "success",
        offset: 200
      });
    },
    alert_error(message) {
      this.$message({
        message: message,
        type: "error",
        offset: 200
      });
    },
    //
    submit() {
      this.axios
        .get(this.serve + "/personal/change_bind_mobile", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            bind_mobile: this.form.mobile,
            phone_code: this.form.msgCode
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            alert_success("手机号已更改");
            this.$router.push("/user/userInfo");
          } else {
            this.alert_error(res.data.msg);
          }
        });
    },
    getMessageCode() {
      this.axios
        .get(this.serve + "/personal/send_change_bind", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            bind_mobile: this.form.mobile,
            code: this.form.imgCode
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            alert_success("短信已发送");
            this.text1 = "60s后重新发送";
            this.msgDisable = true;
            var t = 60;
            var that = this;
            var t1 = setInterval(function() {
              t--;
              if (t == 0) {
                clearInterval(t1);
                that.msgDisable = false;
                that.text1 = "获取短信";
              } else {
                that.text1 = t + "s后重新发送";
              }
            }, 1000);

            if (res.data.status == "success") {
            }
          } else {
            if (res.data.msg == "未知错误") {
              this.alert_error("操作失败");
            } else {
              this.alert_error(res.data.msg);
            }
          }
        });
    }
  }
};
</script>
<style lang="scss">
#bindMobile {
  min-height: 600px;
  background-color: #fff;
  padding: 50px 0 100px 0;
  .form {
    width: 500px;
    margin: 0 auto;
  }
  .submit {
    width: 150px;
  }
}
</style>